export function ProfileIcon({
  className = '',
  size = 24,
}: {
  className?: string;
  size?: number | string;
}) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="none"
      height={size}
      viewBox="0 0 24 24"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.75 20.75V17.75C2.75 13.884 5.88401 10.75 9.75 10.75H13.75C17.616 10.75 20.75 13.884 20.75 17.75V20.75M16.75 5.75C16.75 8.51142 14.5114 10.75 11.75 10.75C8.98858 10.75 6.75 8.51142 6.75 5.75C6.75 2.98858 8.98858 0.75 11.75 0.75C14.5114 0.75 16.75 2.98858 16.75 5.75Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}
